import { Box, Grid, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import makeStyles from "@mui/styles/makeStyles";
import React, { useCallback, useEffect, useState } from "react";
import FilesDisplayList from "../../Components/FilesDisplayList";
import service from "../../helpers/GifService";
import { useSelector } from "react-redux";
import {
  applicantSelector,
  canEditSelector,
  reportingAsSelector,
} from "../../../../store/applicantsSlice";
import { useLoading } from "../../../../providers/loadingProvider";
import { useConfirm } from "../../../../Contexts/ConfirmContext/ConfirmService";
import ApplicantSelector from "../../Components/applicantSelector";
import {
  colleaguesSelector,
  proposalSelector,
} from "../../../../store/proposalSlice";
import {
  programTypes,
  PRE_PROPOSAL_STATUS,
} from "../../Constants";

const PUBLICATION_FILE_NAME = "apppublication";
//const BRIEF_BIOS_FILE_NAME = "appbios";
const APPLICANT_BIO = "applicantbio";

const filesData = [
  // {
  //   name: BRIEF_BIOS_FILE_NAME,
  //   category: "Brief bios of the Principal Investigators",
  //   files: [],
  //   program: "all",
  //   stages: [],
  // },
  {
    name: APPLICANT_BIO,
    category: "Applicant BIO",
    files: [],
    programs: "all",
    stages: [PRE_PROPOSAL_STATUS],
  },
  {
    name: PUBLICATION_FILE_NAME,
    category: "List of PI's relevant publications of the past 5 years",
    files: [],
    program: "all",
    stages: [],
  },
];

const useStyles = makeStyles((theme) => ({
  infoIcon: {
    marginLeft: 5,
    display: "inline-block",
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  header: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
}));

export default function ApplicantDocs() {
  const classes = useStyles();
  const confirm = useConfirm();
  const loading = useLoading();
  const applicant = useSelector(applicantSelector);
  const [applicantToView, setApplicantToView] = useState(null);
  const as = useSelector(reportingAsSelector);
  const canEdit = useSelector(canEditSelector);
  const colleagues = useSelector(colleaguesSelector);
  const proposal = useSelector(proposalSelector);
  const [files, setFiles] = useState([]);

  const getFiles = useCallback(async () => {
    setFiles([]);
    const applicantId = applicantToView;
    if (!applicantId) return;
    const loadingId = loading.addLoading("fetching files");
    let withFiles = filesData;
    var applicantFiles = await service.getApplicantsFiles({ applicantId });
    withFiles.forEach((file) => {
      file.files = applicantFiles.filter((f) =>
        f.name.includes(`${applicantId}_${file.name}`)
      );
    });
    withFiles = withFiles.filter(
      (file) =>
        file.stages.length === 0 || file.stages.includes(proposal.status)
    );
    setFiles(withFiles);
    loading.removeLoading(loadingId);
  }, [applicantToView, loading, proposal.status]);

  const uploadFile = async ({ file, fileName }) => {
    const loadingId = loading.addLoading("uploading File");
    await service
      .UploasApplicantFile({ file, applicantId: applicantToView, fileName })
      .then(() => {});
    loading.removeLoading(loadingId);
    getFiles();
  };

  const deleteFile = async ({ fileName }) => {
    const res = await confirm({
      title: "Delete File",
      description: "Are you sure you want to delete this file?",
    });
    if (!res) return;

    const loadingId = loading.addLoading("deleting file");
    const applicantId = applicantToView;
    await service.deleteApplicantFile({ id: applicantId, fileName });
    getFiles();
    loading.removeLoading(loadingId);
  };

  const downloadFile = async (fileName) => {
    const applicantId = applicantToView;
    const loadingId = loading.addLoading("downloading file");

    var data = await service.downloadApplicantFiles({
      id: applicantId,
      fileName,
    });
    loading.removeLoading(loadingId);
    if (!(data instanceof Blob)) {
      return;
    }
    const blob = new Blob([data], { type: "application/pdf" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `${fileName}.pdf`;
    link.click();
  };

  const applicantChange = (applicant) => {
    const applicantId = applicant.id;
    setApplicantToView(applicantId);
  };

  useEffect(() => {
    getFiles();
  }, [getFiles]);

  useEffect(() => {
    if (!applicant) return;
    if (as) {
      const asApplicant = colleagues.filter((c) => c.email === as)[0];
      setApplicantToView(asApplicant.id);
    } else {
      setApplicantToView(applicant.id);
    }
  }, [colleagues, as, applicant]);

  return (
    <>
      <Grid container>
        <Box className={classes.header}>
          <Typography variant="subtitle2">Applicant Docs</Typography>
          <InfoOutlinedIcon className={classes.infoIcon} color="primary" />
          <ApplicantSelector onChange={applicantChange} />
          <Typography style={{ color: "red" }} variant="caption">
            *Only PDF files can be uploaded
          </Typography>
        </Box>
        {proposal.programType === programTypes.SoloTrack &&
          proposal.status === PRE_PROPOSAL_STATUS && (
            <Grid item xs={12}>
              <Typography style={{ color: "red" }} variant="caption">
                *Please upload your Doctoral Degree Certificate along with your
                Bio (total 2 pages)
              </Typography>
            </Grid>
          )}
      </Grid>
      <Grid item xs={12}>
        {files.map((file) => (
          <FilesDisplayList
            key={`${file.name}`}
            filesCategory={file.category}
            fileName={file.name}
            files={file.files || []}
            uploadFile={uploadFile}
            deleteFile={deleteFile}
            downloadFile={downloadFile}
            disabled={!canEdit}
            multipleFiles={file.multiple}
          />
        ))}
      </Grid>
    </>
  );
}
